import {
    LibrarySymbolInfo,
    ResolutionString,
} from 'public/charting_library/charting_library';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import GOOGLIMAGE from '/pairs/alphabet--big.svg';
// ================================
// 📦 Import local assets
// ================================
import BNBIMAGE from '/pairs/BNBUSDT.png';
import BTCIMAGE from '/pairs/BTCUSDT.png';
import ETHIMAGE from '/pairs/ETHUSDT.png';
// import EURUSDIMAGE from '/pairs/EURUSD.png';
// import GBPJPYIMAGE from '/pairs/GBPJPY.png';
// import GBPUSDIMAGE from '/pairs/GBPUSD.png';
import NFLXIMAGE from '/pairs/netflix--big.svg';
import OILIMAGE from '/pairs/OILUSD.png';
import OPIMAGE from '/pairs/OPUSDT.png';
import SOLIMAGE from '/pairs/SOLUSDT.png';
import TSLAIMAGE from '/pairs/tesla--big.svg';
import WLDIMAGE from '/pairs/WLDUSDT.png';
import XAGIMAGE from '/pairs/XAGUSD.png';
import XAUTIMAGE from '/pairs/XAUTUSDT.png';
// import XAUIMAGE from '/pairs/XAUUSD.png';

// import XPDUSD from '/pairs/XPDUSD.png';
// import XPTUSD from '/pairs/XPTUSD.png';

export interface Pair {
    name: string;
    symbol: string;
    decimals: number;
    imageUrl: string;
    pairIndex: number;
    indexPrice: number;
    listedDate: string;
    decimalsToShow: number;
    group: number;
    chartName: string;
    groupName: string;
    maxOpenInterest: string;
    maxLeverage: number;
    isFuture?: boolean;
    historyCall?: string;
    nameDisplay: string;
    isClose?: boolean;
    tag?: string;
    isDevelopment?: boolean;
    isNoSupport24h?: boolean;
    minLeverage?: number | undefined;
    address?: string;
    isAlwaysOpen?: boolean;
    feeRate?: number;
    // max leveraged position size (USD) allowed on this pair alone
    maxPosition?: number;
}

export enum HistoryCallType {
    okx = 'okx',
    holdstation = 'holdstation',
}

const pairs: Pair[] = [
    // ================================
    // 🪙 CRYPTO
    // ================================
    {
        name: 'Bitcoin',
        symbol: 'BTCUSDT',
        nameDisplay: 'BTCUSD',
        decimals: 8,
        imageUrl: BTCIMAGE,
        pairIndex: 0,
        indexPrice: 0,
        listedDate: '1689662312000',
        decimalsToShow: 2,
        group: 0,
        chartName: 'BINANCE:BTCUSDT',
        groupName: 'crypto',
        maxOpenInterest: '100000000000000000000000',
        maxLeverage: 100,
        maxPosition: 25000,
    },
    {
        name: 'Ethereum',
        symbol: 'ETHUSDT',
        nameDisplay: 'ETHUSD',
        decimals: 18,
        imageUrl: ETHIMAGE,
        pairIndex: 1,
        indexPrice: 1,
        listedDate: '1689662312000',
        decimalsToShow: 2,
        group: 0,
        chartName: 'BINANCE:ETHUSDT',
        groupName: 'crypto',
        maxOpenInterest: '100000000000000000000000',
        maxLeverage: 100,
        maxPosition: 10000,
    },
    {
        name: 'Worldcoin',
        symbol: 'WLDUSDT',
        nameDisplay: 'WLDUSD',
        decimals: 18,
        imageUrl: WLDIMAGE,
        pairIndex: 22,
        indexPrice: 22,
        listedDate: '1738945879000',
        decimalsToShow: 4,
        group: 0,
        chartName: 'BINANCE:WLDUSDT',
        groupName: 'crypto',
        maxOpenInterest: '100000000000000000000000',
        maxLeverage: 5,
        maxPosition: 5000,
    },
    {
        name: 'Optimism',
        symbol: 'OPUSDT',
        nameDisplay: 'OPUSD',
        decimals: 18,
        imageUrl: OPIMAGE,
        pairIndex: 91,
        indexPrice: 91,
        listedDate: '1748593972000',
        decimalsToShow: 4,
        group: 0,
        chartName: 'BINANCE:OPUSDT',
        groupName: 'crypto',
        maxOpenInterest: '100000000000000000000000',
        maxLeverage: 50,
        maxPosition: 5000,
    },
    {
        name: 'Tether Gold',
        symbol: 'XAUTUSDT',
        nameDisplay: 'XAUTUSD',
        decimals: 18,
        imageUrl: XAUTIMAGE,
        pairIndex: 92,
        indexPrice: 92,
        listedDate: '1748593972000',
        decimalsToShow: 2,
        historyCall: 'okx',
        group: 2,
        chartName: 'OKX:XAUTUSDT',
        groupName: 'crypto',
        maxOpenInterest: '100000000000000000000000',
        maxLeverage: 150,
        tag: 'HOT',
        maxPosition: 25000,
    },
    {
        name: 'Solana',
        symbol: 'SOLUSDT',
        nameDisplay: 'SOLUSD',
        decimals: 18,
        imageUrl: SOLIMAGE,
        pairIndex: 26,
        indexPrice: 26,
        listedDate: '1689751500000',
        decimalsToShow: 2,
        group: 0,
        chartName: 'BINANCE:SOLUSDT',
        groupName: 'crypto',
        maxOpenInterest: '100000000000',
        maxLeverage: 100,
        maxPosition: 10000,
    },
    {
        name: 'Binance Coin',
        symbol: 'BNBUSDT',
        nameDisplay: 'BNBUSD',
        decimals: 18,
        imageUrl: BNBIMAGE,
        pairIndex: 10,
        indexPrice: 10,
        listedDate: '1689662312000',
        decimalsToShow: 3,
        group: 0,
        chartName: 'BINANCE:BNBUSDT',
        groupName: 'crypto',
        maxOpenInterest: '100000000000',
        maxLeverage: 100,
        maxPosition: 10000,
    },
    // {
    //     name: 'Toncoin',
    //     symbol: 'TONUSDT',
    //     nameDisplay: '  TONUSD',
    //     decimals: 18,
    //     imageUrl: '/pairs/TONUSDT.png',
    //     pairIndex: 33,
    //     indexPrice: 33,
    //     listedDate: '1738945879000',
    //     decimalsToShow: 4,
    //     group: 0,
    //     chartName: 'BINANCE:TONUSDT',
    //     groupName: 'crypto',
    //     maxOpenInterest: '100000000000000000000000',
    //     maxLeverage: 20,
    // },
    // {
    //     name: 'DOGS',
    //     symbol: 'DOGSUSDT',
    //     nameDisplay: 'DOGSUSD',
    //     decimals: 18,
    //     imageUrl: '/pairs/DOGSUSDT.png',
    //     pairIndex: 81,
    //     indexPrice: 81,
    //     listedDate: '1738945879000',
    //     decimalsToShow: 7,
    //     group: 0,
    //     chartName: 'BINANCE:DOGSUSDT',
    //     groupName: 'crypto',
    //     maxOpenInterest: '100000000000000000000000',
    //     maxLeverage: 20,
    // },
    // ================================
    // 🛢 COMMODITIES
    // ================================
    // {
    //     name: 'XAU',
    //     symbol: 'XAUUSD',
    //     nameDisplay: 'XAUUSD',
    //     decimals: 18,
    //     imageUrl: XAUIMAGE,
    //     pairIndex: 2,
    //     indexPrice: 2,
    //     listedDate: '1753418155000',
    //     decimalsToShow: 2,
    //     historyCall: 'holdstation',
    //     group: 2,
    //     chartName: 'BINANCE:XAUUSD',
    //     groupName: 'commodities-1',
    //     maxOpenInterest: '10000000000000000000000000',
    //     maxLeverage: 250,
    //     tag: 'HOT',
    // },
    {
        name: 'Silver',
        symbol: 'XAGUSD',
        nameDisplay: 'XAGUSD',
        decimals: 18,
        imageUrl: XAGIMAGE,
        pairIndex: 110,
        indexPrice: 110,
        listedDate: '1957608836000',
        decimalsToShow: 4,
        group: 2,
        chartName: 'FOREXCOM:XAGUSD',
        groupName: 'commodities-1',
        historyCall: 'holdstation',
        maxLeverage: 150,
        maxOpenInterest: '500000000000000000000000',
        isNoSupport24h: true,
        tag: 'HOT',
        // isAlwaysOpen: true,
        maxPosition: 25000,
    },
    {
        name: 'OIL',
        symbol: 'OILUSD',
        nameDisplay: 'OILUSD',
        decimals: 18,
        imageUrl: OILIMAGE,
        pairIndex: 19,
        indexPrice: 19,
        listedDate: '1753418152000',
        decimalsToShow: 2,
        historyCall: 'holdstation',
        group: 2,
        chartName: 'BINANCE:OILUSD',
        groupName: 'commodities-1',
        maxOpenInterest: '10000000000000000000000000',
        maxLeverage: 150,
        isNoSupport24h: true,
        maxPosition: 25000,
    },

    // {
    //     name: 'XPTUSD',
    //     symbol: 'XPTUSD',
    //     nameDisplay: 'XPTUSD',
    //     decimals: 18,
    //     imageUrl: XPTUSD,
    //     pairIndex: 112,
    //     indexPrice: 112,
    //     listedDate: '1753418152000',
    //     decimalsToShow: 2,
    //     historyCall: 'holdstation',
    //     group: 2,
    //     chartName: 'BINANCE:XPTUSD',
    //     groupName: 'commodities-1',
    //     maxOpenInterest: '10000000000000000000000000',
    //     maxLeverage: 250,
    //     isNoSupport24h: true,
    //     feeRate: 2,
    //     tag: 'NEW',
    //     isDevelopment: true,
    // },

    // {
    //     name: 'XPDUSD',
    //     symbol: 'XPDUSD',
    //     nameDisplay: 'XPDUSD',
    //     decimals: 18,
    //     imageUrl: XPDUSD,
    //     pairIndex: 114,
    //     indexPrice: 114,
    //     listedDate: '1753418152000',
    //     decimalsToShow: 2,
    //     historyCall: 'holdstation',
    //     group: 2,
    //     chartName: 'BINANCE:XPDUSD',
    //     groupName: 'commodities-1',
    //     maxOpenInterest: '10000000000000000000000000',
    //     maxLeverage: 250,
    //     isNoSupport24h: true,
    //     feeRate: 2,
    //     tag: 'NEW',
    //     isDevelopment: true,
    // },

    // ================================
    // 💱 FOREX
    // ================================
    // {
    //     name: 'GBPJPY',
    //     symbol: 'GBPJPY',
    //     nameDisplay: 'GBPJPY',
    //     decimals: 18,
    //     imageUrl: GBPJPYIMAGE,
    //     pairIndex: 3,
    //     indexPrice: 3,
    //     listedDate: '1689662312000',
    //     decimalsToShow: 2,
    //     group: 1,
    //     chartName: 'FOREXCOM:GBPJPY',
    //     maxLeverage: 500,
    //     minLeverage: 10,
    //     groupName: 'forex',
    //     maxOpenInterest: '80000000000000000',
    //     isNoSupport24h: true,
    // },
    // {
    //     name: 'GBPUSD',
    //     symbol: 'GBPUSD',
    //     nameDisplay: 'GBPUSD',
    //     decimals: 18,
    //     imageUrl: GBPUSDIMAGE,
    //     pairIndex: 5,
    //     indexPrice: 5,
    //     listedDate: '1689662312000',
    //     decimalsToShow: 5,
    //     maxLeverage: 500,
    //     minLeverage: 10,
    //     group: 1,
    //     chartName: 'FOREXCOM:GBPUSD',
    //     groupName: 'forex',
    //     maxOpenInterest: '80000000000000000',
    //     isNoSupport24h: true,
    // },
    // {
    //     name: 'EURUSD',
    //     symbol: 'EURUSD',
    //     nameDisplay: 'EURUSD',
    //     decimals: 18,
    //     imageUrl: EURUSDIMAGE,
    //     pairIndex: 4,
    //     indexPrice: 4,
    //     listedDate: '1689662312000',
    //     decimalsToShow: 5,
    //     maxLeverage: 500,
    //     minLeverage: 10,
    //     group: 1,
    //     chartName: 'FOREXCOM:EURUSD',
    //     groupName: 'forex',
    //     maxOpenInterest: '80000000000000000',
    //     isNoSupport24h: true,
    // },

    // ================================
    // 💱 STOCK
    // ================================
    {
        name: 'AAPL',
        symbol: 'AAPLUSD',
        nameDisplay: 'AAPLUSD',
        decimals: 8,
        imageUrl: '/pairs/alphabet--big.svg',
        pairIndex: 93,
        indexPrice: 93,
        listedDate: '1755734400000',
        decimalsToShow: 2,
        group: 5,
        chartName: 'AAPLUSD:AAPLUSD',
        groupName: 'stock',
        historyCall: 'holdstation',
        maxOpenInterest: '50000000000000000000',
        maxLeverage: 50,
        isNoSupport24h: true,
    },
    {
        name: 'NFLX',
        symbol: 'NFLXUSD',
        nameDisplay: 'NFLXUSD',
        decimals: 8,
        imageUrl: NFLXIMAGE,
        pairIndex: 94,
        indexPrice: 94,
        listedDate: '1755734400000',
        decimalsToShow: 2,
        group: 5,
        chartName: 'NFLXUSD:NFLXUSD',
        groupName: 'stock',
        historyCall: 'holdstation',
        maxOpenInterest: '50000000000000000000',
        maxLeverage: 50,
        isNoSupport24h: true,
    },
    {
        name: 'GOOGL',
        symbol: 'GOOGLUSD',
        nameDisplay: 'GOOGLUSD',
        decimals: 8,
        imageUrl: GOOGLIMAGE,
        pairIndex: 95,
        indexPrice: 95,
        listedDate: '1755734400000',
        decimalsToShow: 2,
        group: 5,
        chartName: 'GOOGLUSD:GOOGLUSD',
        groupName: 'stock',
        historyCall: 'holdstation',
        maxOpenInterest: '50000000000000000000',
        maxLeverage: 50,
        isNoSupport24h: true,
    },
    {
        name: 'TSLA',
        symbol: 'TSLAUSD',
        nameDisplay: 'TSLAUSD',
        decimals: 8,
        imageUrl: TSLAIMAGE,
        pairIndex: 96,
        indexPrice: 96,
        listedDate: '1755734400000',
        decimalsToShow: 2,
        group: 5,
        chartName: 'TSLAUSD:TSLAUSD',
        groupName: 'stock',
        historyCall: 'holdstation',
        maxOpenInterest: '50000000000000000000',
        maxLeverage: 50,
        isNoSupport24h: true,
    },
];

function resolveSymbols(data: Pair[]) {
    const cryptoPairs: LibrarySymbolInfo[] = data
        .filter((x) => x.group === 0)
        .map((x) => {
            let listed_exchange = x.isFuture ? 'binance_future' : 'binance';
            const exchange = x.chartName.split(':');
            if (exchange.length > 1 && exchange[0].toLowerCase() === 'bybit') {
                listed_exchange = 'bybit';
            }

            if (
                exchange.length > 1 &&
                exchange[0].toLowerCase() === 'holdstation'
            ) {
                listed_exchange = 'holdstation';
            }

            if (exchange.length > 1 && exchange[0].toLowerCase() === 'poly') {
                listed_exchange = 'poly';
            }

            if (exchange.length > 1 && exchange[0].toLowerCase() === 'okx') {
                listed_exchange = 'okx';
            }

            return {
                name: x.chartName.split(':')[1],
                decimalsToShow: x.decimalsToShow,
                listed_exchange: listed_exchange,
                symbol: x.symbol,
            };
        })
        .map((o) => ({
            ticker: o.name,
            name: `${o.name} name`,
            description: `${o.symbol}`,
            full_name: `${o.name} full name`,
            listed_exchange: o.listed_exchange,
            format: 'price',
            type: 'crypto',
            session: '24x7',
            timezone: 'Etc/UTC',
            exchange: '',
            minmov: 1,
            pricescale: Math.pow(10, o.decimalsToShow),
            has_intraday: true,
            has_no_volume: true,
            has_weekly_and_monthly: true,
            supported_resolutions: [
                '1',
                '5',
                '15',
                '1h',
                '4h',
                '24h',
            ] as ResolutionString[],
            volume_precision: 2,
            data_status: 'streaming',
        }));

    const forexPairs: LibrarySymbolInfo[] = data
        .filter((x) => x.group === 1 || x.group === 2 || x.group === 3)
        .map((x) => {
            return {
                name: x.chartName.split(':')[1],
                decimalsToShow: x.decimalsToShow,
            };
        })
        .map((o) => ({
            ticker: o.name,
            name: `${o.name} name`,
            description: `${o.name}`,
            full_name: `${o.name} full name`,
            listed_exchange: 'forex',
            format: 'price',
            type: 'forex',
            session: '24x7',
            timezone: 'Etc/UTC',
            exchange: 'forex',
            minmov: 1,
            pricescale: Math.pow(10, o.decimalsToShow),
            has_intraday: true,
            has_no_volume: true,
            has_weekly_and_monthly: true,
            supported_resolutions: [
                '1',
                '5',
                '15',
                '1h',
                '4h',
                '24h',
            ] as ResolutionString[],
            volume_precision: 5,
            data_status: 'streaming',
        }));

    const politicPairs: LibrarySymbolInfo[] = data
        .filter((x) => x.group === 4)
        .map((x) => {
            const exchange = x.chartName.split(':')[0].toLowerCase();

            return {
                name: x.chartName.split(':')[1],
                decimalsToShow: x.decimalsToShow,
                listed_exchange: exchange,
                symbol: x.symbol,
            };
        })
        .map((o) => ({
            ticker: o.name,
            name: `${o.name} name`,
            description: `${o.symbol}`,
            full_name: `${o.name} full name`,
            listed_exchange: o.listed_exchange,
            format: 'price',
            type: 'polictics',
            session: '24x7',
            timezone: 'Etc/UTC',
            exchange: '',
            minmov: 1,
            pricescale: Math.pow(10, o.decimalsToShow),
            has_intraday: true,
            has_no_volume: true,
            has_weekly_and_monthly: true,
            supported_resolutions: [
                '5',
                '15',
                '1h',
                '4h',
                '24h',
            ] as ResolutionString[],
            volume_precision: 2,
            data_status: 'streaming',
        }));

    const stockPairs: LibrarySymbolInfo[] = data
        .filter((x) => x.group === 5)
        .map((x) => {
            const exchange = x.chartName.split(':')[0].toLowerCase();

            return {
                name: x.chartName.split(':')[1],
                decimalsToShow: x.decimalsToShow,
                listed_exchange: exchange,
                symbol: x.symbol,
            };
        })
        .map((o) => ({
            ticker: o.name,
            name: `${o.name} name`,
            description: `${o.symbol}`,
            full_name: `${o.name} full name`,
            listed_exchange: 'stock',
            format: 'price',
            type: 'polictics',
            session: '24x7',
            timezone: 'Etc/UTC',
            exchange: '',
            minmov: 1,
            pricescale: Math.pow(10, o.decimalsToShow),
            has_intraday: true,
            has_no_volume: true,
            has_weekly_and_monthly: true,
            supported_resolutions: [
                '5',
                '15',
                '1h',
                '4h',
                '24h',
            ] as ResolutionString[],
            volume_precision: 2,
            data_status: 'streaming',
        }));

    return [...cryptoPairs, ...forexPairs, ...politicPairs, ...stockPairs];
}

export const usePairs = create(
    immer<{ data: Pair[]; symbols: LibrarySymbolInfo[] }>(() => ({
        data: pairs,
        symbols: resolveSymbols(pairs),
    }))
);
